import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';
import { BRAND_ASSETS } from '../data';

export default function BygGarantiPage() {
  return (
    <div className="bg-stone-100 min-h-screen">
      <PageSEO
        title="Medlem af DI Byggeri og Byg Garanti | KTS-Entreprise A/S"
        description="KTS-Entreprise er medlem af DI Byggeri og tilsluttet Byg Garanti."
        ogTitle="Medlem af DI Byggeri og Byg Garanti | KTS-Entreprise A/S"
        ogDescription="KTS-Entreprise er medlem af DI Byggeri og tilsluttet Byg Garanti."
        ogImage={BRAND_ASSETS.defaultOgImage}
        slug="byg-garanti"
      />

      {/* Header Banner */}
      <section className="bg-stone-900 text-white pt-36 sm:pt-44 md:pt-48 lg:pt-52 pb-12 sm:pb-16 border-b-4 border-[#0072c0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#0072c0]/20 border border-[#0072c0]/40 text-blue-200 text-xs font-heading font-bold uppercase tracking-wider mb-3 rounded-xs">
            <span>Garantiordning</span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-black uppercase tracking-tight text-white font-heading">
            Medlem af DI Byggeri og Byg Garanti
          </h1>
          <p className="text-stone-300 text-sm sm:text-base mt-2 max-w-2xl">
            KTS-Entreprise er tilsluttet Byg Garanti gennem vores medlemskab af DI Byggeri.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="bg-white border border-stone-200 p-6 sm:p-10 rounded-xs shadow-xs max-w-4xl mx-auto space-y-6">
          <div className="flex items-center gap-4 border-b border-stone-200 pb-6">
            <img
              src={BRAND_ASSETS.diBadgeLarge}
              alt="Medlem af DI Byggeri"
              className="h-12 w-auto object-contain"
            />
            <div>
              <h2 className="font-heading font-bold text-xl sm:text-2xl text-stone-900 uppercase">
                Medlem af DI Byggeri og Byg Garanti
              </h2>
            </div>
          </div>

          <p className="text-stone-700 text-base sm:text-lg leading-relaxed">
            KTS-Entreprise er medlem af DI Byggeri og tilsluttet Byg Garanti. Ordningen giver private forbrugere en ekstra sikkerhed ved bestemte typer håndværksarbejde. Dækningen afhænger af arbejdets type og de til enhver tid gældende betingelser.
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            <a
              href={BRAND_ASSETS.diLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#0072c0] hover:bg-[#005b99] text-white text-xs sm:text-sm font-heading font-bold uppercase tracking-wider px-5 py-3 rounded-xs transition-colors shadow-xs"
            >
              <span>Bekræft KTS-Entreprises medlemskab</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
            </a>

            <a
              href={BRAND_ASSETS.bygGarantiConditionsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-white text-xs sm:text-sm font-heading font-bold uppercase tracking-wider px-5 py-3 rounded-xs transition-colors"
            >
              <span>Læs de gældende betingelser hos Byg Garanti</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
            </a>
          </div>

          <div className="pt-8 border-t border-stone-200">
            <Link to="/om-os" className="text-xs font-heading font-bold uppercase text-[#0072c0] hover:underline flex items-center gap-2">
              <i className="fa-solid fa-arrow-left text-xs"></i>
              <span>Læs mere om KTS-Entreprise på Om os</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
